import EventCard from "../event card/EventCard";
import classes from "./programList.module.scss";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Link } from "react-router-dom";
import EventList from "../Event List/EventList";
import tripsTypes from "../../assets/data/tripsTypes";
import { ArrowRightAlt } from "@mui/icons-material";

const ProgramList = (props) => {
  const ProgramCards = props.events;

  return (
    <div className={classes.main}>
      <div className={classes.secHeader}>
        {props.title && <h3>Current Programs</h3>}
      </div>
      <div className={classes.container}>
        {ProgramCards?.map((card) => (
          <EventCard
            id={card._id}
            key={card._id}
            img={card.image}
            title={card.name}
            date={card.startDate}
            duration={card.duration}
            location={card.location}
            price={card.price}
            isRecurrent={card.isRecurrent}
            load={props.load}
            type={tripsTypes[card.type]?.name}
            review={props.review}
            wishlist={props.wishlist}
          />
        ))}
      </div>
      {!props.load && (
        <Link
          to="/programs"
          className={`see_more ${classes.seemore}`}
          scroll="yes"
        >
          Explore Programs <ArrowRightAlt />
        </Link>
      )}
      <div className={classes.alice}>
        <EventList events={ProgramCards} title={false} load={props.load} />
        <Link to="/programs" className={"see_more"} scroll="yes">
          Explore Programs <ArrowRightAlt />
        </Link>
      </div>
    </div>
  );
};

export default ProgramList;
